// extracted by mini-css-extract-plugin
export default {"confirmedAgainPopup":"Style_confirmedAgainPopup__EYSwY"};